import { SaleStatus } from './sale'

export const SALE_PAYMENT_PROVIDER_OPTIONS = [
  { value: '', label: 'All sales types' },
  { value: 'false', label: 'Sales through Tablelist' },
  { value: 'true', label: 'Sales through Stripe Connect' },
] as const

export const SALE_INVENTORY_TYPE_OPTIONS = [
  { value: '', label: 'All inventory types' },
  { value: 'TICKET', label: 'Tickets', queryValue: ['TICKET'] as string[] },
  {
    value: 'TABLE_PACKAGE',
    label: 'Packages/Tables',
    queryValue: ['TABLE', 'PACKAGE'] as string[],
  },
] as const

export const SALE_PAYMENT_TYPE_OPTIONS = [
  { value: '', label: 'All payment types' },
  {
    value: 'VENUE',
    label: 'Pay at the venue',
    queryValue: ['VENUE'] as string[],
  },
  {
    value: 'ADVANCE',
    label: 'Pay in advance',
    queryValue: ['ADVANCE', 'ADVANCE_DEPOSIT'] as string[],
  },
  { value: 'NONE', label: 'No Payment', queryValue: ['NONE'] as string[] },
] as const

export const SALE_STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: SaleStatus.OPEN, label: 'Open' },
  { value: SaleStatus.CANCELLED, label: 'Cancelled' },
  { value: SaleStatus.REFUNDED, label: 'Refunded' },
] as const

export const DATA_EXPORT_SPECIAL_QUERY_KEYS = [
  'venueId',
  'customerId',
  'customerTagId',
  'sort',
  'date',
  'dateStart',
  'dateEnd',
  'saleDateStart',
  'saleDateEnd',
  'exportDateStart',
  'exportDateEnd',
  'hasPaymentProviderAccountId',
  'eventId',
  'cityId',
  'affiliateId',
  'status',
  'inventoryType',
  'paymentType',
] as const
